<template>
  <div class="scroll_flex_container">
    <div v-if="isLoginVerifying" class="loading-container">
      <div class="spinner"></div>
      <p class="loading-text">登入驗證中...</p>
    </div>

    <div class="unlogin-cover h-full w-full" v-else-if="!isLogin">
      <levitateLoginCard />
    </div>
    <div v-if="!isLoginVerifying" class="row_end_center member_card_container">
      <memberCard></memberCard>
    </div>

    <div v-if="!isLoginVerifying" class="column_center_start card_container">
      <div
        class="row_end_center carrier_container"
        :style="{ height: isLogin ? '280px' : '320px' }"
      >
        <carrierCard style="margin-top: 45px"></carrierCard>
      </div>
      <!-- <invitation v-if="isLogin" /> -->
      <div class="link_button_container" :class="{ not_login: !isLogin }">
        <linkButton
          v-for="(item, index) in displayButtonsArray"
          :key="item.routerName || item.name"
          :buttonItem="item"
          :index="index"
        ></linkButton>
      </div>
    </div>

    <!-- 新增：店家公告跳窗組件 -->
    <StoreNoticePopup
      v-if="
        !isLoginVerifying &&
        !isClaimPopupOpen &&
        !isOfferDetailPopupOpen &&
        !openPage
      "
    />
    <couponOfferDetailPopup
      v-if="isOfferDetailPopupOpen && !isLogin && !isLoginVerifying"
      :key="getOfferDetailKey"
      :offerUuid="claimOfferUuid"
      :isLoginStarting="isClaimLoginStarting"
      @login="startClaimLogin"
      @close="closeOfferDetailPopup"
    />
    <couponClaimPopup
      v-if="isClaimPopupOpen"
      :offerUuid="claimOfferUuid"
      @close="isClaimPopupOpen = false"
    />
  </div>
</template>

<script>
import carrierCard from "../components/home/carrierCard.vue";
import linkButton from "../components/home/linkButton.vue";
import memberCard from "../components/home/memberCard.vue";
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
// import invitation from '@/components/home/invitation.vue'
import levitateLoginCard from "@/components/home/levitateLoginCard.vue";
import StoreNoticePopup from "@/components/general/storeNoticePopup.vue";
import couponClaimPopup from "@/components/coupon/couponClaimPopup.vue";
import couponOfferDetailPopup from "@/components/coupon/couponOfferDetailPopup.vue";
import apiData from "@/services/apiData";
import {
  CLAIM_OFFER_QUERY_KEY,
  CLAIM_LOGIN_QUERY_KEY,
  OPEN_CLAIMED_COUPONS,
  OPEN_PAGE_QUERY_KEY,
  getClaimOfferUuid,
  getIsClaimLoginReturn,
  getOpenPage,
  withoutClaimOffer,
  withoutClaimLogin,
  withoutOpenPage,
} from "@/utils/couponClaimLink.utils";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    CarrierCard: carrierCard,
    linkButton: linkButton,
    MemberCard: memberCard,
    // invitation: invitation,
    levitateLoginCard: levitateLoginCard,
    StoreNoticePopup,
    couponClaimPopup,
    couponOfferDetailPopup,
  },
  computed: {
    ...mapGetters("userData", {
      isLogin: "isLogin",
      vipLevel: "vipLevel",
      totalPoints: "totalPoints",
      accessToken: "accessToken",
      storeCode: "storeCode",
      isStoreMember: "isStoreMember",
    }),
    ...mapState("userData", {
      token: "token",
      memberInfo: "memberInfo",
    }),
    ...mapGetters("basic", {
      errorLoginState: "errorLoginState",
      errorLoginMessage: "errorLoginMessage",
      storeName: "storeName",
      isServiceEnabled: "isServiceEnabled",
      hideInactiveServices: "hideInactiveServices",
    }),
    ...mapGetters("line", {
      lineAccessToken: "accessToken",
    }),
    getOfferDetailKey() {
      return `${this.$route.params.store}|${this.claimOfferUuid}|${
        this.$store.getters["userData/storeMemberUuid"] || ""
      }`;
    },
    displayButtonsArray() {
      const serviceTypeMap = {
        LINE下單: 1,
        LINE訂單: 1,
        紅利積分: 3,
        集點商城: 4,
        優惠券: 5,
        保管紀錄: 6,
        問卷: 7,
        行銷活動: 8,
      };

      const buttons = this.buttonsArray.map((item) => {
        const serviceType = serviceTypeMap[item.name];
        if (serviceType === undefined) return item;

        return {
          ...item,
          lock: this.isServiceEnabled(serviceType) ? "" : "priority",
        };
      });

      // 預設顯示（未啟用者上鎖），店家設定 hide_inactive_services 為 0 才隱藏
      if (!this.hideInactiveServices) return buttons;

      // 隱藏所有上鎖的項目，含黑貓商城這類非服務清單管控的項目
      return buttons.filter((item) => !item.lock);
    },
  },
  data() {
    return {
      isLoginVerifying: false,
      hasClaimOffer: false,
      claimOfferUuid: "",
      isClaimPopupOpen: false,
      isOfferDetailPopupOpen: false,
      isClaimLoginStarting: false,
      claimEntrySeq: 0,
      openPage: "",
      buttonsArray: [
        {
          name: "會員",
          icon: "face",
          routerName: "changeMemberInfo",
          lock: null,
          buttonSize: "large",
        },
        {
          name: "營業資訊",
          icon: "store",
          routerName: "storeInfo",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "歷史訂單",
          icon: "storefront",
          routerName: "inStoreOrderHistory",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "黑貓商城",
          icon: "shopping_cart",
          routerName: "marketplace",
          lock: "primary",
          buttonSize: "large",
        },
        {
          name: "LINE下單",
          icon: "restaurant",
          routerName: "onlineOrder",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "LINE訂單",
          icon: "list_alt",
          routerName: "onlineOrderHistory",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "集點商城",
          icon: "scatter_plot",
          routerName: "point",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "紅利積分",
          icon: "savings",
          routerName: "bouns",
          lock: "",
          buttonSize: "large",
        },
        {
          name: "優惠券",
          icon: "local_activity",
          routerName: "coupon",
          lock: "priority",
          buttonSize: "large",
        },
        {
          name: "保管紀錄",
          icon: "credit_card",
          routerName: "deposit",
          lock: "priority",
          buttonSize: "large",
        },
        {
          name: "問卷",
          icon: "assignment",
          routerName: "form",
          lock: "priority",
          buttonSize: "large",
        },
        {
          name: "行銷活動",
          icon: "star",
          routerName: "promotion",
          lock: "priority",
          buttonSize: "large",
        },
        //2026-03-20 決議移除
        //  {
        //   name: "預約紀錄",
        //   icon: 'event_seat',
        //   routerName: "",
        //   lock: "secondary",
        //   buttonSize: "large"
        // },
        // {
        //   name: "履約票卷",
        //   icon: "loyalty",
        //   routerName: "ticket",
        //   lock: "priority",
        //   buttonSize: "large"
        // },
        // {
        //   name: "儲值信託",
        //   icon: "payments",
        //   routerName: "trust",
        //   lock: "priority",
        //   buttonSize: "large"
        // },
      ],
    };
  },
  watch: {
    async $route(to, from) {
      const hasNewClaimOffer = Object.prototype.hasOwnProperty.call(
        to.query,
        CLAIM_OFFER_QUERY_KEY
      );
      // 原流程消費 query 後仍保留已開啟的視窗；只有新入口才重啟。
      if (
        to.params.store !== from.params.store ||
        (hasNewClaimOffer &&
          (to.query[CLAIM_OFFER_QUERY_KEY] !==
            from.query[CLAIM_OFFER_QUERY_KEY] ||
            to.query[CLAIM_LOGIN_QUERY_KEY] !==
              from.query[CLAIM_LOGIN_QUERY_KEY]))
      ) {
        this.isClaimPopupOpen = false;
        await this.initClaimEntry();
      }
    },
    async isLogin(value) {
      if (value && this.isOfferDetailPopupOpen) {
        this.isOfferDetailPopupOpen = false;
        await this.$nextTick();
        await this.init();
      }
    },
    async errorLoginState(state) {
      if (state) {
        //關閉 loading 彈窗
        commonUtils.closeLoading();
        this.isLoginVerifying = false;
        const rawError = this.errorLoginMessage;
        const rawMessage =
          rawError?.response?.data?.err_msg ||
          rawError?.response?.data?.message ||
          rawError?.message ||
          rawError;
        const status = rawError?.response?.status;
        const errorText = String(rawMessage || "");
        const isAuthError =
          status === 401 ||
          status === 403 ||
          errorText === "IdToken expired." ||
          errorText === "token expired" ||
          /unauthorized|request failed with status code 401|token expired|idtoken expired/i.test(
            errorText
          );
        const isNetworkError =
          errorText === "Network Error" ||
          rawError?.code === "ERR_NETWORK" ||
          (!rawError?.response && rawError?.request);

        this.$store.dispatch("basic/setErrorLogin", {
          state: false,
          message: "",
        });

        if (isAuthError) {
          this.$store.commit("line/setLineLoginData", {});
          auth.logout();
          await this.restoreOfferDetailAfterLogin();
          return;
        }

        let errorMessage = "會員頁LINE登入失敗，請稍後再試";
        if (rawMessage == "No Such Store") {
          errorMessage = "查無此店家";
        } else if (isNetworkError) {
          errorMessage = "網路異常，請稍後再試";
        }

        commonUtils.createToast("error", errorMessage);

        this.$store.commit("line/setLineLoginData", {});
        auth.logout();
        await this.restoreOfferDetailAfterLogin();
      }
    },
  },
  async created() {
    this.$store.dispatch("basic/setErrorLogin", { state: false, message: "" });
    await this.initClaimEntry();
  },
  methods: {
    async initClaimEntry() {
      this.claimEntrySeq += 1;
      this.isOfferDetailPopupOpen = false;
      this.isClaimLoginStarting = false;
      const query = this.$route.query;
      this.hasClaimOffer = Object.prototype.hasOwnProperty.call(
        query,
        CLAIM_OFFER_QUERY_KEY
      );
      this.claimOfferUuid = getClaimOfferUuid(query[CLAIM_OFFER_QUERY_KEY]);
      this.openPage = this.hasClaimOffer
        ? ""
        : getOpenPage(query[OPEN_PAGE_QUERY_KEY]);
      if (this.hasClaimOffer && !this.isLogin) {
        const canResumeLogin =
          this.claimOfferUuid &&
          getIsClaimLoginReturn(query[CLAIM_LOGIN_QUERY_KEY]) &&
          this.lineAccessToken;
        if (!canResumeLogin) {
          this.isOfferDetailPopupOpen = true;
          if (!this.claimOfferUuid) {
            await this.$router.replace({
              query: withoutOpenPage(
                withoutClaimLogin(withoutClaimOffer(query))
              ),
            });
          } else if (
            Object.prototype.hasOwnProperty.call(query, CLAIM_LOGIN_QUERY_KEY)
          ) {
            await this.$router.replace({ query: withoutClaimLogin(query) });
          }
          return;
        }
        this.isClaimLoginStarting = true;
      }
      // 匿名元件先卸載清除快照，再交由原領券視窗重新讀取。
      await this.$nextTick();
      await this.init();
    },
    async startClaimLogin() {
      const detail = this.$store.getters["coupon/couponOfferDetail"];
      if (
        this.isLogin ||
        this.isClaimLoginStarting ||
        !this.claimOfferUuid ||
        !this.isOfferDetailPopupOpen ||
        detail?.uuid !== this.claimOfferUuid ||
        detail.loading ||
        detail.data?.offer_uuid !== this.claimOfferUuid
      )
        return;
      this.isClaimLoginStarting = true;
      const data = new apiData();
      data.store = this.$route.params.store;
      data.claim_offer = this.claimOfferUuid;
      try {
        await this.$store.dispatch("line/login", data);
      } catch (error) {
        this.isClaimLoginStarting = false;
        commonUtils.createToast("error", "會員頁LINE登入失敗，請稍後再試");
      }
    },
    async closeOfferDetailPopup() {
      if (this.isClaimLoginStarting) return;
      this.claimEntrySeq += 1;
      this.isOfferDetailPopupOpen = false;
      this.hasClaimOffer = false;
      await this.$router.replace({
        query: withoutOpenPage(
          withoutClaimLogin(withoutClaimOffer(this.$route.query))
        ),
      });
    },
    async restoreOfferDetailAfterLogin() {
      if (!this.hasClaimOffer || this.isLogin || !this.isClaimLoginStarting)
        return;
      this.isClaimLoginStarting = false;
      this.isOfferDetailPopupOpen = true;
      if (
        Object.prototype.hasOwnProperty.call(
          this.$route.query,
          CLAIM_LOGIN_QUERY_KEY
        )
      ) {
        await this.$router.replace({
          query: withoutClaimLogin(this.$route.query),
        });
      }
    },
    async init() {
      const claimEntrySeq = this.claimEntrySeq;
      let loginProcess = false;
      /*
        如果有 line access token 則進行 okShopLogin
        登入後判斷是否為該商店會員 若不是商店會員則直接幫用戶加入會員
      */
      if (!this.isLogin && this.lineAccessToken) {
        loginProcess = true;
        this.isLoginVerifying = true;
        // 顯示讀loading 彈窗
        /*
        //Modify By Bryant 2025061701//
        commonUtils.createLoading("資料讀取中", "請稍後");
        */
        try {
          await auth.okShopLogin();
        } catch (e) {
          console.error("Failed to login gen2 pos system:", e);
          this.$store.dispatch("basic/setErrorLogin", {
            state: true,
            message: e,
          });
          this.$store.commit("line/setLineLoginData", {});
          this.isLoginVerifying = false;
          //Modify By Bryant 2025061701//
          commonUtils.closeLoading();
          if (claimEntrySeq === this.claimEntrySeq)
            await this.restoreOfferDetailAfterLogin();
          return;
        }
      } else if (!this.accessToken) {
        // 如果沒有 okshop access token || line access token 則不進行任何動作
        //Modify By Bryant 2025061701//
        this.isLoginVerifying = false;
        commonUtils.closeLoading();
        return;
      }

      try {
        // 如果不是該商店會員 則進行加入會員
        if (!this.isStoreMember) {
          await this.$store.dispatch("userData/joinMember");
        }
        // 只需等待會員資料讀取完成後，剩餘資料可在背景讀取
        await this.$store.dispatch("userData/fetchMemberInfo");
        await this.$store.dispatch("basic/fetchStoreInfo");
        await this.$store.dispatch("basic/fetchStoreServicesList");
        // 載入店家圖片（背景執行，不阻塞其他流程）
        // 注意：action 內部會檢查登入狀態，未登入時會使用快取
        this.$store.dispatch("basic/fetchStoreImages");
        this.$store.dispatch("spreadsheet/getSpreadSheetData");
        this.$store.dispatch("userData/fetchPointHistory");
        this.$store.dispatch("payment/getPaymentMethods");
      } catch (e) {
        console.error(e);
        commonUtils.closeLoading();
        this.isLoginVerifying = false;
        commonUtils.createToast("error", `會員資料讀取失敗`);
        if (claimEntrySeq === this.claimEntrySeq)
          await this.restoreOfferDetailAfterLogin();
        return;
      }

      if (claimEntrySeq !== this.claimEntrySeq) return;
      this.isClaimLoginStarting = false;
      if (loginProcess) {
        commonUtils.closeLoading();
        this.isLoginVerifying = false;
        commonUtils.createToast("success", "登入成功", "");
      }
      if (this.hasClaimOffer) {
        this.isClaimPopupOpen = true;
        this.$router.replace({
          query: withoutOpenPage(
            withoutClaimLogin(withoutClaimOffer(this.$route.query))
          ),
        });
      } else if (this.openPage === OPEN_CLAIMED_COUPONS) {
        // replace 避免返回時回到帶 open 的網址又被導回優惠券頁
        this.$router.replace({
          name: "coupon",
          params: { store: this.$route.params.store },
          query: { tab: "claimed" },
        });
      } else if (
        Object.prototype.hasOwnProperty.call(
          this.$route.query,
          OPEN_PAGE_QUERY_KEY
        )
      ) {
        this.$router.replace({
          query: withoutOpenPage(this.$route.query),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll_flex_container {
  min-height: 100vh;
}

.loading-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  padding: 40px 20px;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f0f0f0;
  border-top-color: #fd5001;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loading-text {
  margin-top: 16px;
  color: #666;
  font-size: 16px;
  letter-spacing: 0.64px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.member_card_container {
  width: 100vw;
  height: 205px;
  padding-top: 20px;
  background-image: url("../assets/member_card_container_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.card_container {
  margin-top: -60px;
}

.carrier_container {
  background-image: url("../assets/member_card_cover.png");
  width: 100vw;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.link_button_container {
  width: 90vw;
  display: grid;
  place-items: center;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  padding: 10px 0;
  margin: 0 auto;
}

.not_login {
  // opacity: 0.4;
}
</style>
